import React from 'react';

const TermsSummary = ({ children }) => {
  return (
    <div className="terms-summary">
      <div className="subheading">Terms summary</div>
      <p className="text-gray">
        These are the current terms that your collaborator has proposed. Only
        changes made by the creator of the agreement will be displayed here.
      </p>
      <p className="text-gray f-12 text-italic">
        Note: If an attorney has redlined this agreement, the points below may
        have changed and may not be applicable. Carefully read and review your
        entire agreement before proceeding.
      </p>
      {children}
    </div>
  );
};

export default TermsSummary;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/TermsSummary.js